import React, { useState } from "react";
import { useIntl } from "react-intl";

import InfluencerCategoryInput from "../../AudiencesSearch/components/filters/InfluencerCategoryInput";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import METHODS from "../../../helpers/methods";

export default function InfluencerCategory({
  unifiedCategories,
  chosenUnifiedCategories,
  unifiedCategoryClick,
  setChosenUnifiedCategories,
  hasInfluencerSocialUsername,
  handleEnterPress,
}) {
  const [searchUnifiedCategories, setSearchUnifiedCategories] = useState("");
  const intl = useIntl();
  return (
    <div
      className="creator-search-filters__content-wrapper"
      data-qa="filter_influencer_category"
    >
      <InfluencerCategoryInput
        influencerCategoryValueInput={searchUnifiedCategories}
        onKeyPress={(e) => handleEnterPress(e, "unifiedCategories")}
        onChangeInfluencerCategoryValueInput={(e) => {
          setSearchUnifiedCategories(e.target.value);
        }}
        isDisabled={hasInfluencerSocialUsername}
        label={
          <IDHFormattedMessage id="front_category" defaultMessage="Category" />
        }
        dataCdtAttribute="creator-interests"
      />

      <SelectTags
        feed={unifiedCategories.filter((item) =>
          METHODS.doesTextIncludeSearchTerm(
            intl.formatMessage({
              id: item.name,
              defaultMessage: item.value,
            }),
            searchUnifiedCategories,
          ),
        )}
        values={chosenUnifiedCategories}
        setValue={(item) => {
          unifiedCategoryClick(item.value);
        }}
        unsetValue={unifiedCategoryClick}
        clearValues={() => setChosenUnifiedCategories([])}
        translative
        getFullObject={(subtag) =>
          METHODS.findObjBySubTag(subtag, unifiedCategories)
        }
        disabled={hasInfluencerSocialUsername}
        isExpandable
      />
    </div>
  );
}
